__turbopack_context__.v({
  "container": "QotViG_container",
  "containerDark": "QotViG_containerDark",
  "containerLight": "QotViG_containerLight",
  "dateContainer": "QotViG_dateContainer",
  "dateStyle": "QotViG_dateStyle",
  "dateStyleDark": "QotViG_dateStyleDark",
  "dateStyles": "QotViG_dateStyles",
  "imgStyles": "QotViG_imgStyles",
  "imgWrapper": "QotViG_imgWrapper",
  "mainSkeletonStyles": "QotViG_mainSkeletonStyles",
  "marginBotton10": "QotViG_marginBotton10",
  "marginBotton15": "QotViG_marginBotton15",
  "marginBt10Larg": "QotViG_marginBt10Larg",
  "marginTop20px": "QotViG_marginTop20px",
  "tagStyleDark": "QotViG_tagStyleDark",
  "tagStylesText1": "QotViG_tagStylesText1",
  "tagStylesTextDark": "QotViG_tagStylesTextDark",
  "timeDuration": "QotViG_timeDuration",
  "titleStyles": "QotViG_titleStyles",
  "titleStylesDark": "QotViG_titleStylesDark",
  "verticalLline": "QotViG_verticalLline",
  "videoDurationStyles": "QotViG_videoDurationStyles",
});
